import classNames from "classnames";
import {
  sectionTitles,
  TWebsiteBuilderSectionType,
} from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderSection";
import React from "react";
import { TWebsiteBuilderSectionViewHighlight } from "./WebsiteBuilderSectionView";
import { websiteBuilderZLayers } from "../../../../websiteBuilderZLayers";

interface ISectionHighlightTitleProps {
  highlight: TWebsiteBuilderSectionViewHighlight;
  type: TWebsiteBuilderSectionType;
}

export function SectionHighlightTitle(props: ISectionHighlightTitleProps) {
  const { highlight, type } = props;

  return (
    <>
      {highlight !== "none" && (
        <div
          className={classNames("website-builder-section-highlight-title", {
            "section-highlight-title-weak-highlight": highlight === "weak",
            "section-highlight-title-strong-highlight": highlight === "strong",
            "section-highlight-title-bottom": type === "header",
            "section-highlight-title-top": type !== "header",
          })}
          style={{
            zIndex: websiteBuilderZLayers.designSpace.sectionEditorUI,
          }}
        >
          {sectionTitles[type]}
        </div>
      )}
    </>
  );
}
